import { motion } from 'framer-motion'
import { Bot, ArrowRight, ShieldAlert, Github, FileCheck } from 'lucide-react'

export function ControlledExecution() {
  const steps = [
    { icon: Bot, label: 'AI Assistant', delay: 0 },
    { icon: ShieldAlert, label: 'Approval Gate', delay: 0.8 },
    { icon: Github, label: 'GitHub API', delay: 1.6 },
    { icon: FileCheck, label: 'Audit Log', delay: 2.4 },
  ]

  return (
    <section className="py-24 sm:py-32 bg-ground border-t border-line relative overflow-hidden">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 relative z-10 text-center">
        <h2 className="text-3xl sm:text-4xl font-semibold text-ink tracking-tight mb-4">
          AI with boundaries.
        </h2>
        <p className="max-w-2xl mx-auto text-lg text-ink-muted leading-relaxed mb-16">
          Give your assistant real access without giving it uncontrolled power. Every sensitive action stops and waits for your explicit approval.
        </p>
        
        <div className="max-w-4xl mx-auto relative">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 md:gap-0 relative z-10">
            {steps.map((step, i) => {
              const Icon = step.icon
              return (
                <div key={i} className="flex flex-col md:flex-row items-center relative w-full md:w-auto">
                  
                  {/* Node */}
                  <motion.div 
                    initial={{ opacity: 0.5, scale: 0.9 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    transition={{ delay: step.delay, duration: 0.5 }}
                    viewport={{ once: true }}
                    className={`w-20 h-20 rounded-2xl border border-line bg-surface flex items-center justify-center shadow-card relative z-10
                      ${i === 1 ? 'border-waiting/50 bg-waiting/10' : ''}`}
                  >
                    <Icon className={`w-8 h-8 ${i === 1 ? 'text-waiting' : 'text-primary'}`} />
                    <div className="absolute -bottom-8 whitespace-nowrap text-xs font-semibold text-ink-muted uppercase tracking-wider">
                      {step.label}
                    </div>
                  </motion.div>

                  {/* Connector Arrow */}
                  {i < steps.length - 1 && (
                    <div className="hidden md:flex flex-1 w-24 items-center justify-center relative overflow-hidden">
                      <div className="w-full h-px bg-line absolute" />
                      <motion.div 
                        initial={{ x: '-100%' }}
                        whileInView={{ x: '100%' }}
                        transition={{ delay: step.delay + 0.4, duration: 0.8, repeat: Infinity, repeatDelay: 3 }}
                        className="w-1/2 h-px bg-gradient-to-r from-transparent via-primary to-transparent absolute z-20"
                      />
                      <ArrowRight className="w-4 h-4 text-line-strong absolute z-10" />
                    </div>
                  )}

                  {/* Vertical Connector for Mobile */}
                  {i < steps.length - 1 && (
                    <div className="md:hidden h-12 w-px bg-line my-2 relative overflow-hidden">
                      <motion.div 
                        initial={{ y: '-100%' }}
                        whileInView={{ y: '100%' }}
                        transition={{ delay: step.delay + 0.4, duration: 0.8, repeat: Infinity, repeatDelay: 3 }}
                        className="h-1/2 w-px bg-gradient-to-b from-transparent via-primary to-transparent absolute z-20"
                      />
                    </div>
                  )}

                </div>
              )
            })}
          </div>
        </div>
      </div>
    </section>
  )
}
